import React from "react";
import Services from "../Services/Services";
import GoaPackage from './GoaPackage'
import KeralaPackage from './KeralaPackage';
import DubaiPackage from './DubaiPackage';
export default function ServicesApp(){
    return(
        <>
        
        <Services/>
        <GoaPackage/>
        <KeralaPackage/>
        <DubaiPackage/>
        </>
    )
}